import NotFoundPage from "../pages/NotFoundPage.vue";

const notFoundRoutes = [
    {
        path: '/:pathMatch(.*)*',
        name: "NotFoundPage",
        component: NotFoundPage,
        meta: {
            breadcrumb: () => {
                return []
            }
        }
    },
]

export default notFoundRoutes